import { defineAsyncComponent } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';

import SkippersList from './pages/skippers/SkippersList.vue';
//import SkipperDetail from './pages/skippers/SkipperDetail.vue';
//import SkipperRegistration from './pages/skippers/SkipperRegistration.vue';
import RequestsReceived from './pages/requests/RequestsReceived.vue';
import ContactSkipper from './pages/requests/ContactSkipper.vue';
import UserAuth from './pages/auth/UserAuth.vue';
import NotFound from './pages/NotFound.vue';
import store from './store/index.js';

const SkipperDetail = defineAsyncComponent(() =>
  import('./pages/skippers/SkipperDetail.vue')
);
const SkipperRegistration = defineAsyncComponent(() =>
  import('./pages/skippers/SkipperRegistration.vue')
);

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/skipper' },
    { path: '/skipper', component: SkippersList },
    {
      path: '/skipper/:id',
      component: SkipperDetail,
      props: true,
      children: [{ path: 'contact', component: ContactSkipper }]
    },
    {
      path: '/register',
      component: SkipperRegistration,
      meta: { requiresAuth: true }
    },
    {
      path: '/requests',
      component: RequestsReceived,
      meta: { requiresAuth: true }
    },
    { path: '/auth', component: UserAuth, meta: { requiresUnauth: true } },
    { path: '/:notFround(.*)', component: NotFound }
  ]
});

router.beforeEach(function(to, _, next) {
  if (to.meta.requiresAuth && !store.getters.isAuthenticated) {
    next('/auth');
  } else if (to.meta.requiresUnauth && store.getters.isAuthenticated) {
    next('/skipper');
  } else {
    next();
  }
});

export default router;
